import altonTheme from 'typography-theme-alton'

import { TypographyOptions } from './types.js'

export const typography: TypographyOptions = {
  /**
   * @tag Vite migration
   * 'typography-theme-alton' module provides a default export and breaks Rollup ESM-CJS interop
   * https://github.com/vitejs/vite/issues/2139#issuecomment-1024852072
   */
  ...(altonTheme.default ? altonTheme.default : altonTheme),
  baseFontSize: '16px',
}
